module.exports = __webpack_public_path__ + "asset/image-mailbox-7f9c957df6d7e0e4.svg";


//////////////////
// WEBPACK FOOTER
// ./src/application/scene/identity/scene/forgot-password/scene/forgot-password-confirm/image/mailbox.svg
// module id = 2C65
// module chunks = 0